/*jslint node: true*/

"use strict";

var ko = require("pli/knockout");

//-------------------------------------------
function createNormalItem(options, record) {
    return options.targetArray.createItem(record);
}


//-------------------------------------------
function createMappedItem(options, record) {
    var key, o = {};
    for (key in options.rowMap) {
        if (options.rowMap.hasOwnProperty(key)) {
            o[key] = record[options.rowMap[key]];
        }
    }
    return createNormalItem(options, o);
}


//-------------------------------------------
function pushItems(options, targetItemCreator) {
    var target = options.targetArray.peek();
    var getIdentity = (typeof options.getIdentity === "function" ? options.getIdentity : null);
    var targetChanged = false;
    var records = options.records;

    var i, l, j, m, newItem, newIdentity, targetIdentity;
    for (i = 0, l = records.length; i < l; i += 1) {
        newItem = targetItemCreator(options, records[i]);
        if (getIdentity) {
            newIdentity = getIdentity(newItem);
            if (newIdentity !== null) {
                for (j = 0, m = target.length; j < m; j += 1) {
                    targetIdentity = getIdentity(target[j]);
                    if (targetIdentity !== null) {
                        if (newIdentity === targetIdentity) {
                            ko.disposeObject(newItem);
                            newItem = null;
                            break;
                        }
                    }
                }
            }
        }
        if (newItem !== null) {
            targetChanged = true;
            target.push(newItem);
        }
    }
    if (targetChanged) {
        // sort with forced notification
        options.targetArray.sort(null, target, true);
    }
    return options.targetArray;
}


//-------------------------------------------
function pushObjectItems(options) {
    return pushItems(options, createNormalItem);
}


//-------------------------------------------
function pushRowItems(options) {
    return pushItems(options, createMappedItem);
}


//-------------------------------------------
function resetGuids(root) {
    /// <summary>
    /// Utility method exposed via "selectionForm.utils"
    /// that recursively traverses specified object
    /// and arrays and sets all properties called
    /// "guid" to null. Useful when copying (as opposed
    /// to linking).
    /// </summary>
    if (root !== null && typeof root === "object") {
        var i, l;
        if (root.indexOf) { // naive array detection
            root = ko.utils.unwrapObservable(root); // unwrap if observable array
            for (i = 0, l = root.length; i < l; i += 1) {
                resetGuids(root[i]);
            }
        } else {
            var key, guidValue, child;
            if (!ko.utils.unwrapObservable(root.link)) {
                for (key in root) {
                    if (root.hasOwnProperty(key)) {
                        if (key === "guid") {
                            guidValue = root[key];
                            if (ko.isObservable(guidValue)) {
                                guidValue(null);
                            } else {
                                root[key] = null;
                            }
                        } else {
                            child = ko.utils.unwrapObservable(root[key]); // unwrap child, if observable
                            resetGuids(child);
                        }
                    }
                }
            }
        }
    }
    return root;
}

module.exports = {
    pushObjectItems: pushObjectItems,
    pushRowItems: pushRowItems,
    resetGuids: resetGuids
};



//////////////////
// WEBPACK FOOTER
// ./app/common-selectionform/selectionFormUtils.js
// module id = 525
// module chunks = 49